import React, { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './PortfolioPage.css';
import { setPageTitle, pageTitles, pageDescriptions } from '../utils/pageTitle';

const PortfolioPage = () => {
  const { t, localizedPath, language } = useLanguage();

  useEffect(() => {
    setPageTitle(pageTitles.portfolio, pageDescriptions.portfolio, 'portfolio', language);
  }, [language]);

  const [selectedCountry, setSelectedCountry] = useState('');
  const [selectedIndustry, setSelectedIndustry] = useState('');

  const countries = ['United States', 'United Kingdom', 'Germany', 'Canada', 'Netherlands'];
  const industries = ['Cloud', 'Enterprise', 'Mobile', 'DevOps', 'Healthcare', 'E-Commerce', 'Sales & Marketing'];

  const getProjects = () => [
    {
      id: 1,
      key: 'cloudify',
      title: t('portfolio.projects.cloudify.title'),
      industry: t('portfolio.projects.cloudify.industry'),
      country: t('portfolio.projects.cloudify.country'),
      description: t('portfolio.projects.cloudify.description'),
      longDescription: t('portfolio.projects.cloudify.longDescription'),
      image: '/images/cloudify.webp',
      services: t('portfolio.projects.cloudify.services'),
      technologies: t('portfolio.projects.cloudify.technologies'),
      results: t('portfolio.projects.cloudify.results'),
      timeline: t('portfolio.projects.cloudify.timeline'),
      client: t('portfolio.projects.cloudify.client')
    },
    {
      id: 2,
      key: 'earlysense',
      title: t('portfolio.projects.earlysense.title'),
      industry: t('portfolio.projects.earlysense.industry'),
      country: t('portfolio.projects.earlysense.country'),
      description: t('portfolio.projects.earlysense.description'),
      longDescription: t('portfolio.projects.earlysense.longDescription'),
      image: '/images/earlysense.webp',
      services: t('portfolio.projects.earlysense.services'),
      technologies: t('portfolio.projects.earlysense.technologies'),
      results: t('portfolio.projects.earlysense.results'),
      timeline: t('portfolio.projects.earlysense.timeline'),
      client: t('portfolio.projects.earlysense.client')
    },
    {
      id: 3,
      key: 'dell',
      title: t('portfolio.projects.dell.title'),
      industry: t('portfolio.projects.dell.industry'),
      country: t('portfolio.projects.dell.country'),
      description: t('portfolio.projects.dell.description'),
      longDescription: t('portfolio.projects.dell.longDescription'),
      image: '/images/dell.webp',
      services: t('portfolio.projects.dell.services'),
      technologies: t('portfolio.projects.dell.technologies'),
      results: t('portfolio.projects.dell.results'),
      timeline: t('portfolio.projects.dell.timeline'),
      client: t('portfolio.projects.dell.client')
    },
    {
      id: 4,
      key: 'envoy',
      title: t('portfolio.projects.envoy.title'),
      industry: t('portfolio.projects.envoy.industry'),
      country: t('portfolio.projects.envoy.country'),
      description: t('portfolio.projects.envoy.description'),
      longDescription: t('portfolio.projects.envoy.longDescription'),
      image: '/images/envoy.webp',
      services: t('portfolio.projects.envoy.services'),
      technologies: t('portfolio.projects.envoy.technologies'),
      results: t('portfolio.projects.envoy.results'),
      timeline: t('portfolio.projects.envoy.timeline'),
      client: t('portfolio.projects.envoy.client')
    },
    {
      id: 5,
      key: 'geofree',
      title: t('portfolio.projects.geofree.title'),
      industry: t('portfolio.projects.geofree.industry'),
      country: t('portfolio.projects.geofree.country'),
      description: t('portfolio.projects.geofree.description'),
      longDescription: t('portfolio.projects.geofree.longDescription'),
      image: '/images/geofreesoftware.webp',
      services: t('portfolio.projects.geofree.services'),
      technologies: t('portfolio.projects.geofree.technologies'),
      results: t('portfolio.projects.geofree.results'),
      timeline: t('portfolio.projects.geofree.timeline'),
      client: t('portfolio.projects.geofree.client')
    },
    {
      id: 6,
      key: 'moretech',
      title: t('portfolio.projects.moretech.title'),
      industry: t('portfolio.projects.moretech.industry'),
      country: t('portfolio.projects.moretech.country'),
      description: t('portfolio.projects.moretech.description'),
      longDescription: t('portfolio.projects.moretech.longDescription'),
      image: '/images/moretech.webp',
      services: t('portfolio.projects.moretech.services'),
      technologies: t('portfolio.projects.moretech.technologies'),
      results: t('portfolio.projects.moretech.results'),
      timeline: t('portfolio.projects.moretech.timeline'),
      client: t('portfolio.projects.moretech.client')
    },
    {
      id: 7,
      key: 's2cript',
      title: t('portfolio.projects.s2cript.title'),
      industry: t('portfolio.projects.s2cript.industry'),
      country: t('portfolio.projects.s2cript.country'),
      description: t('portfolio.projects.s2cript.description'),
      longDescription: t('portfolio.projects.s2cript.longDescription'),
      image: '/images/s2cript.svg',
      services: t('portfolio.projects.s2cript.services'),
      technologies: t('portfolio.projects.s2cript.technologies'),
      results: t('portfolio.projects.s2cript.results'),
      timeline: t('portfolio.projects.s2cript.timeline'),
      client: t('portfolio.projects.s2cript.client')
    },
    {
      id: 8,
      key: 'itmyway',
      title: t('portfolio.projects.itmyway.title'),
      industry: t('portfolio.projects.itmyway.industry'),
      country: t('portfolio.projects.itmyway.country'),
      description: t('portfolio.projects.itmyway.description'),
      longDescription: t('portfolio.projects.itmyway.longDescription'),
      image: '/images/itmyway.webp',
      services: t('portfolio.projects.itmyway.services'),
      technologies: t('portfolio.projects.itmyway.technologies'),
      results: t('portfolio.projects.itmyway.results'),
      timeline: t('portfolio.projects.itmyway.timeline'),
      client: t('portfolio.projects.itmyway.client')
    },
    {
      id: 9,
      key: 'inventionland',
      title: t('portfolio.projects.inventionland.title'),
      industry: t('portfolio.projects.inventionland.industry'),
      country: t('portfolio.projects.inventionland.country'),
      description: t('portfolio.projects.inventionland.description'),
      longDescription: t('portfolio.projects.inventionland.longDescription'),
      image: '/images/inventionland.webp',
      services: t('portfolio.projects.inventionland.services'),
      technologies: t('portfolio.projects.inventionland.technologies'),
      results: t('portfolio.projects.inventionland.results'),
      timeline: t('portfolio.projects.inventionland.timeline'),
      client: t('portfolio.projects.inventionland.client')
    },
    {
      id: 10,
      key: 'cloudytech',
      title: t('portfolio.projects.cloudytech.title'),
      industry: t('portfolio.projects.cloudytech.industry'),
      country: t('portfolio.projects.cloudytech.country'),
      description: t('portfolio.projects.cloudytech.description'),
      longDescription: t('portfolio.projects.cloudytech.longDescription'),
      image: '/images/cloudytech.webp',
      services: t('portfolio.projects.cloudytech.services'),
      technologies: t('portfolio.projects.cloudytech.technologies'),
      results: t('portfolio.projects.cloudytech.results'),
      timeline: t('portfolio.projects.cloudytech.timeline'),
      client: t('portfolio.projects.cloudytech.client')
    },
    {
      id: 11,
      key: 'goto',
      title: t('portfolio.projects.goto.title'),
      industry: t('portfolio.projects.goto.industry'),
      country: t('portfolio.projects.goto.country'),
      description: t('portfolio.projects.goto.description'),
      longDescription: t('portfolio.projects.goto.longDescription'),
      image: '/images/goto.webp',
      services: t('portfolio.projects.goto.services'),
      technologies: t('portfolio.projects.goto.technologies'),
      results: t('portfolio.projects.goto.results'),
      timeline: t('portfolio.projects.goto.timeline'),
      client: t('portfolio.projects.goto.client')
    },
    {
      id: 12,
      key: 'acumatica',
      title: t('portfolio.projects.acumatica.title'),
      industry: t('portfolio.projects.acumatica.industry'),
      country: t('portfolio.projects.acumatica.country'),
      description: t('portfolio.projects.acumatica.description'),
      longDescription: t('portfolio.projects.acumatica.longDescription'),
      image: '/images/acumatica.webp',
      services: t('portfolio.projects.acumatica.services'),
      technologies: t('portfolio.projects.acumatica.technologies'),
      results: t('portfolio.projects.acumatica.results'),
      timeline: t('portfolio.projects.acumatica.timeline'),
      client: t('portfolio.projects.acumatica.client')
    },
    {
      id: 13,
      key: 'innovo',
      title: t('portfolio.projects.innovo.title'),
      industry: t('portfolio.projects.innovo.industry'),
      country: t('portfolio.projects.innovo.country'),
      description: t('portfolio.projects.innovo.description'),
      longDescription: t('portfolio.projects.innovo.longDescription'),
      image: '/images/innovo.webp',
      services: t('portfolio.projects.innovo.services'),
      technologies: t('portfolio.projects.innovo.technologies'),
      results: t('portfolio.projects.innovo.results'),
      timeline: t('portfolio.projects.innovo.timeline'),
      client: t('portfolio.projects.innovo.client')
    },
    {
      id: 14,
      key: 'eddiebauer',
      title: t('portfolio.projects.eddiebauer.title'),
      industry: t('portfolio.projects.eddiebauer.industry'),
      country: t('portfolio.projects.eddiebauer.country'),
      description: t('portfolio.projects.eddiebauer.description'),
      longDescription: t('portfolio.projects.eddiebauer.longDescription'),
      image: '/images/eddiebauer.webp',
      services: t('portfolio.projects.eddiebauer.services'),
      technologies: t('portfolio.projects.eddiebauer.technologies'),
      results: t('portfolio.projects.eddiebauer.results'),
      timeline: t('portfolio.projects.eddiebauer.timeline'),
      client: t('portfolio.projects.eddiebauer.client')
    },
    {
      id: 15,
      key: 'hamdan',
      title: t('portfolio.projects.hamdan.title'),
      industry: t('portfolio.projects.hamdan.industry'),
      country: t('portfolio.projects.hamdan.country'),
      description: t('portfolio.projects.hamdan.description'),
      longDescription: t('portfolio.projects.hamdan.longDescription'),
      image: '/images/hamdan.webp',
      services: t('portfolio.projects.hamdan.services'),
      technologies: t('portfolio.projects.hamdan.technologies'),
      results: t('portfolio.projects.hamdan.results'),
      timeline: t('portfolio.projects.hamdan.timeline'),
      client: t('portfolio.projects.hamdan.client')
    },
    {
      id: 16,
      key: 'logsios',
      title: t('portfolio.projects.logsios.title'),
      industry: t('portfolio.projects.logsios.industry'),
      country: t('portfolio.projects.logsios.country'),
      description: t('portfolio.projects.logsios.description'),
      longDescription: t('portfolio.projects.logsios.longDescription'),
      image: '/images/logsios.webp',
      services: t('portfolio.projects.logsios.services'),
      technologies: t('portfolio.projects.logsios.technologies'),
      results: t('portfolio.projects.logsios.results'),
      timeline: t('portfolio.projects.logsios.timeline'),
      client: t('portfolio.projects.logsios.client')
    },
    {
      id: 17,
      key: 'pixelpurehat',
      title: t('portfolio.projects.pixelpurehat.title'),
      industry: t('portfolio.projects.pixelpurehat.industry'),
      country: t('portfolio.projects.pixelpurehat.country'),
      description: t('portfolio.projects.pixelpurehat.description'),
      longDescription: t('portfolio.projects.pixelpurehat.longDescription'),
      image: '/images/pixel_pure_hat_logo.jpeg',
      services: t('portfolio.projects.pixelpurehat.services'),
      technologies: t('portfolio.projects.pixelpurehat.technologies'),
      results: t('portfolio.projects.pixelpurehat.results'),
      timeline: t('portfolio.projects.pixelpurehat.timeline'),
      client: t('portfolio.projects.pixelpurehat.client'),
      website: 'https://www.pixelpurehat.com/'
    },
    {
      id: 18,
      key: 'adgptise',
      title: t('portfolio.projects.adgptise.title'),
      industry: t('portfolio.projects.adgptise.industry'),
      country: t('portfolio.projects.adgptise.country'),
      description: t('portfolio.projects.adgptise.description'),
      longDescription: t('portfolio.projects.adgptise.longDescription'),
      image: '/images/adgptise-logo.webp',
      services: t('portfolio.projects.adgptise.services'),
      technologies: t('portfolio.projects.adgptise.technologies'),
      results: t('portfolio.projects.adgptise.results'),
      timeline: t('portfolio.projects.adgptise.timeline'),
      client: t('portfolio.projects.adgptise.client'),
      website: 'https://adgptise.com/'
    }
  ];

  const projects = getProjects();

  const filteredProjects = projects.filter(project => {
    const matchesCountry = !selectedCountry || project.country === selectedCountry;
    const matchesIndustry = !selectedIndustry || project.industry === selectedIndustry;
    return matchesCountry && matchesIndustry;
  });

  const clearFilters = () => {
    setSelectedCountry('');
    setSelectedIndustry('');
  };

  const [selectedProject, setSelectedProject] = useState(null);

  return (
    <div className="portfolio-page">
      <section className="portfolio-hero section">
        <div className="container">
          <div className="portfolio-hero-content">
            <h1 className="page-title">{t('portfolio.title')}</h1>
            <p className="portfolio-hero-description">
              {t('portfolio.subtitle')}
            </p>
          </div>
        </div>
      </section>

      <section className="portfolio-grid-section section">
        <div className="container">
          <div className="portfolio-grid">
            {filteredProjects.map((project) => (
              <div key={project.id} className="portfolio-card" onClick={() => setSelectedProject(project)}>
                <div className="portfolio-image">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="portfolio-img"
                  />
                </div>

                <div className="portfolio-content">
                  <div className="portfolio-description">
                    <p>{project.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {selectedProject && (
        <div className="project-modal" onClick={() => setSelectedProject(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button
              className="modal-close"
              onClick={() => setSelectedProject(null)}
            >
              ×
            </button>

            <div className="modal-header">
              <div className="modal-image">
                <img
                  src={selectedProject.image}
                  alt={selectedProject.title}
                  className="modal-img"
                />
              </div>
              <div className="modal-info">
                <div className="modal-category">{selectedProject.industry}</div>
                <h2 className="modal-title">{selectedProject.title}</h2>
                <p className="modal-client">{t('portfolio.client')}: {selectedProject.client}</p>
                <p className="modal-timeline">{t('portfolio.timeline')}: {selectedProject.timeline}</p>
                {selectedProject.website && (
                  <a
                    className="modal-website"
                    href={selectedProject.website}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {selectedProject.website}
                  </a>
                )}
              </div>
            </div>

            <div className="modal-body">
              <div className="modal-description">
                <h3>{t('portfolio.projectOverview')}</h3>
                <p>{selectedProject.longDescription}</p>
              </div>

              <div className="modal-services">
                <h3>{t('portfolio.servicesProvided')}</h3>
                <div className="services-tags">
                  {selectedProject.services.map((service, index) => (
                    <span key={index} className="service-tag">{service}</span>
                  ))}
                </div>
              </div>

              <div className="modal-technologies">
                <h3>{t('portfolio.technologiesUsed')}</h3>
                <div className="tech-tags">
                  {selectedProject.technologies.map((tech, index) => (
                    <span key={index} className="tech-tag-modal">{tech}</span>
                  ))}
                </div>
              </div>

              <div className="modal-results">
                <h3>{t('portfolio.keyResults')}</h3>
                <ul className="results-list">
                  {selectedProject.results.map((result, index) => (
                    <li key={index} className="result-item">
                      <span className="result-icon">🎯</span>
                      {result}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}

      <section className="portfolio-cta section">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title">{t('portfolio.readyTitle')}</h2>
            <p className="cta-description">
              {t('portfolio.readyDescription')}
            </p>
            <a href={localizedPath('/contact')} className="btn-primary">
              {t('portfolio.startProject')}
              <span className="btn-icon">🚀</span>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PortfolioPage;
